import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { OfficeRouteItem, OfficeRouteService } from '../services/office-route.service';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { ContextService } from '../shared-context/context.service';
import { LocService } from '../shared-context/loc.service';

import './back-button.component.css';

@Component({
    selector: 'ohp-back-button',
    templateUrl: './back-button.component.html'
})
export class BackButtonComponent implements OnInit, OnDestroy {
    @Input() public elementId: string;

    @Input() public backButtonAriaLabel?: string;

    @Input() public defaultBackRoute: OfficeRouteItem;

    @Input() public responsive?: boolean = false;

    @Input() public focusOnLoad?: boolean = false;

    public isRtl: boolean;
    public defaultAriaLabel: string;
    public backRoute: OfficeRouteItem;
    public fluentRefresh: boolean;

    private routeSubscription: Subscription;

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly contextService: ContextService,
        private readonly locService: LocService,
        private readonly officeRouteService: OfficeRouteService
    ) { }

    public ngOnInit() {
        this.defaultAriaLabel = this.locService.CloseAppGalleryAriaLabel;
        this.isRtl = this.contextService.isRtl;
        this.routeSubscription = this.officeRouteService.subscribeToRouteChangeEnd(event => this.backRoute = event.backRoute);
        this.fluentRefresh = this.capabilitiesService.capabilities.fluentRefresh;
    }

    public ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    public navigateBack() {
        if (this.backRoute && this.backRoute.route) {
            this.officeRouteService.back();
        } else if (this.defaultBackRoute) {
            this.officeRouteService.navigateTo(this.defaultBackRoute, true);
        }
    }
}
